import { createFileRoute, redirect } from '@tanstack/react-router';
import type { AuthContextType } from '@/features/auth';
import { getHomeRedirectTarget } from '@/lib/home-redirect';
import * as authLib from '@/lib/auth';

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    const auth = (context as { auth: AuthContextType }).auth;
    const storedUser = authLib.getStoredUser();
    const roles = auth?.user?.roles || storedUser?.roles || [];
    const isAuthenticated = Boolean(auth?.isAuthenticated || authLib.isAuthenticated());
    const redirectTarget = getHomeRedirectTarget({ isAuthenticated, roles });

    throw redirect({ to: redirectTarget, replace: true });
  },
});
